import {
  cssColorValue,
  screenXsMax,
  semanticColors,
} from '@spotify-internal/encore-web';
import styled, { css } from 'styled-components';

export const NavWrapper = styled.nav<{
  isSticky: boolean;
  isTransparent: boolean;
  hasShadow: boolean;
}>`
  display: flex;
  height: 96px;

  ${({ isSticky }) =>
    isSticky &&
    css`
      position: sticky;
      top: 0;
      z-index: 3;
    `}

  ${({ hasShadow }) =>
    hasShadow &&
    css`
      box-shadow: ${cssColorValue(semanticColors.backgroundPress)} 0px -2px 6px;
    `}

  ${({ isTransparent }) =>
    isTransparent &&
    css`
      background: transparent;
      box-shadow: none;
    `}

  @media (max-width: ${screenXsMax}) {
    height: 76px;
  }
`;

export const ContentBackground = styled.div<{
  profileColor?: string;
  isTransparent: boolean;
}>`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 96px;
  margin: auto;
  background-color: ${({ profileColor }) =>
    profileColor || cssColorValue(semanticColors.backgroundBase)};

  ${({ isTransparent }) =>
    isTransparent &&
    css`
      background: transparent;
    `}

  @media (max-width: ${screenXsMax}) {
    height: 76px;
  }
`;

export const ContentWrapper = styled.div<{
  isHidingPrimaryNav: boolean;
}>`
  display: ${({ isHidingPrimaryNav }) =>
    isHidingPrimaryNav ? 'none' : 'flex'};
  align-items: center;
  justify-content: space-around;
  width: 100%;
  max-width: 1400px;
  height: 96px;
  padding: 0 26px;

  @media (max-width: ${screenXsMax}) {
    height: 76px;
  }
`;

export const MainNav = styled.div`
  flex: 1;
`;

export const MobileNav = styled.div`
  display: none;
  @media (max-width: ${screenXsMax}) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
`;

export const DesktopNav = styled.div`
  display: grid;
  grid-template-columns: 2.5fr 5fr 2.5fr;

  @media (max-width: ${screenXsMax}) {
    display: none;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const MainContent = styled(LogoContainer)`
  flex: 1;
  justify-content: center;
`;

export const SideLinks = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-end;
  white-space: nowrap;
`;

export const AccountLinks = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-gap: 28px;
  align-items: center;
`;
